export const API_URL = 'https://waverisehub.inittechnology.co/web-backend';